import fetchManager from '@utils/fetchManager'
import { getEnvironment } from '@utils/general'

const API_URL = getEnvironment("API_DOMAIN");
console.warn('API_URL', API_URL)

export default {
  loginAuth: async (data) => {
    const errorModal = { title: "iniciar sesión" }
    const response = await fetchManager(`${API_URL}/AuthenticationManagement/api/amx/cpe/users/admin/login`, {
      method: 'POST',
      data,
      sendToken: false
    },errorModal)
    return response;
  },

  getUserInfoAuth: async () => {
    const errorModal = { show: 'no', title: 'Prueba' }
    const response = await fetchManager(`${API_URL}/AuthenticationManagement/api/amx/cpe/users/userinfo`, {}, errorModal )
    return response
  },

  getCompleteProfile: async () => {
    const response = await fetchManager(`${API_URL}/IdentityManagement/api/amx/cpe/profiles`)
    return response
  },

  forgotPassword: async (data) => {
    const response = await fetchManager(`${API_URL}/AuthenticationManagement/api/amx/cpe/users/resetpassword`, {
        method: 'POST',
        data,
        sendToken: false
      })
    return response
  },

  validateToken: async (data) => {
    const errorModal = { show: 'no' }

    const response = await fetchManager(`${API_URL}/AuthenticationManagement/api/amx/cpe/users/validatetoken`, {
        method: 'POST',
        data,
        sendToken: false
      }, errorModal)
    return response
  },

  resetPassword: async (data) => {
    const response = await fetchManager(`${API_URL}/AuthenticationManagement/api/amx/cpe/users/resetpassword`, {
        method: 'PUT',
        data,
        sendToken: false
      })
    return response
  },
}